import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';

const FoundationIntro: React.FC = () => {
    const history = useHistory();

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>基金会简介</h1>
                <div className='foundation-content'>
                    <p>绿城爱心基金会以“心理关爱、造福社会、创造价值、彰显品牌”为宗旨</p>
                    <p>以造福社会、创造价值为使命，以“理想生活、健康人生”为愿景</p>
                    <p>立足于心理健康方面的公益慈善事业。</p>
                </div>
            </div>
        } />
    );
};

export default FoundationIntro;